// components/dialogs/NoEmailConfirmationDialog.tsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface NoEmailConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export const NoEmailConfirmationDialog: React.FC<NoEmailConfirmationDialogProps> = ({
  open,
  onClose,
  onContinue,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Please Add Email Address</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please add an email address if possible as this helps us to contact and support the customer effectively in the future.
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Button
          variant="text"
          onClick={onContinue}
          sx={{ cursor: "pointer" }}
        >
          Continue Saving
        </Button>
        <Button
          onClick={onClose}
          color="warning"
          variant="contained"
        >
          Go Back
        </Button>
      </DialogActions>
    </Dialog>
  );
};
